import React, { Component } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MainSwitch from '@mui/material/Switch';
import '../assets/styles/switch.css';

/**
 * Switch komponenta.
 */
class Switch extends Component {
    /**
     * Default props.
     *
     * @type {{
     *     label: string,
     *     color: string,
     *     checked: boolean,
     *     onChange: function,
     * }}
     */
    static defaultProps = {
        label: '',
        color: 'primary',
        checked: false,
        onChange: () => {},
    };

    /**
     * Default state.
     *
     * @type {{
     *     checked: boolean
     * }}
     */
    state = {
        checked: false,
    };

    /**
     * Komponenta bola pripojena.
     */
    componentDidMount() {
        const { checked } = this.props;

        // Nasetujeme value do state z props
        this.setState({ checked });
    }

    /**
     * Komponenta bola zmenena.
     *
     * @param {Object} prevProps
     * @param {Object} prevState
     * @param snapshot
     */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.checked !== this.props.checked) {
            // Nesedi hodnota v state a props, aktualizujeme
            this.setState({ checked: this.props.checked });
        }
    }

    /**
     * Event po zmene.
     *
     * @param {boolean} checked
     */
    onChange(checked) {
        this.setState({ checked });

        this.props.onChange(checked);
    }

    /**
     * Rendrovanie.
     *
     * @return {JSX.Element}
     */
    render() {
        const { label, color } = this.props;
        const { checked } = this.state;

        return (
            <FormControlLabel
                control={
                    <MainSwitch
                        checked={checked}
                        onChange={event => this.onChange(event.target.checked)}
                        color={color}
                    />
                }
                label={label}
                className="switch"
            />
        );
    }
}

export { Switch };
